<template>
    <div class="modal" :id="compModal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered" style="max-width: 900px;">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title text-center">
                        Create Contact
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body bg-light" style="">
                    <fieldset>

                        <div class="row">
                            <div class="col-lg-6">
                                <div class="block block-rounded mb-0">

                                    <div class="block-header block-header-default">
                                        <h3 class="block-title">
                                            Contact
                                        </h3>
                                    </div>

                                    <div class="block-content block-content-full">

                                        <div class="form-group mb-2">
                                            <CustomerSelect
                                                :customer="internalSelectedCustomer"
                                                v-model="internalSelectedCustomer"
                                                :required="true"
                                                remove-margin
                                            />
                                        </div>

                                        <div class="form-group mb-2">
                                            <label :for="compName">
                                                <strong>
                                                    Name
                                                    <span class="text-danger">*</span>
                                                </strong>
                                            </label>
                                            <input class="form-control"
                                                   :name="compName"
                                                   :id="compName"
                                                   v-model="name"
                                                   placeholder="Name"
                                                   type="text"
                                                   required
                                            >
                                        </div>

                                        <div class="form-group mb-2">
                                            <label :for="compPosition">
                                                <strong>
                                                    Position
                                                    <span class="text-danger">*</span>
                                                </strong>
                                            </label>
                                            <input class="form-control"
                                                   :name="compPosition"
                                                   :id="compPosition"
                                                   v-model="position"
                                                   placeholder="Manager at..."
                                                   type="text"
                                                   required
                                            >
                                        </div>

                                        <div class="form-group mb-2">
                                            <label :for="compEmail">
                                                <strong>
                                                    Email
                                                    <span class="text-danger">*</span>
                                                </strong>
                                            </label>
                                            <input class="form-control"
                                                   :name="compEmail"
                                                   :id="compEmail"
                                                   v-model="email"
                                                   placeholder="person@example.com"
                                                   type="text"
                                                   required
                                            >
                                        </div>

                                        <div class="form-group">
                                            <label :for="compNumber">
                                                <strong>
                                                    Phone Number
                                                    <span class="text-danger">*</span>
                                                </strong>
                                            </label>
                                            <input class="form-control"
                                                   :id="compNumber"
                                                   :name="compNumber"
                                                   v-model="number"
                                                   placeholder="0123456789"
                                                   type="text"
                                                   required
                                            >
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6">
                                <div class="block block-rounded mb-0">

                                    <div class="block-header block-header-default">
                                        <h3 class="block-title">Address</h3>
                                    </div>

                                    <div class="block-content block-content-full">

                                        <div class="form-group mb-2">
                                            <label :for="compAddress1">
                                                <strong>
                                                    Address Line 1
                                                    <span class="text-danger">*</span>
                                                </strong>
                                            </label>
                                            <input class="form-control"
                                                   :id="compAddress1"
                                                   :name="compAddress1"
                                                   v-model="address1"
                                                   placeholder="Address Line 1"
                                                   type="text"
                                                   required
                                            >
                                        </div>

                                        <div class="form-group mb-2">
                                            <label :for="compAddress2">
                                                <strong>
                                                    Address Line 2
                                                    <span class="text-danger">*</span>
                                                </strong>
                                            </label>
                                            <input class="form-control"
                                                   :id="compAddress2"
                                                   :name="compAddress2"
                                                   v-model="address2"
                                                   placeholder="Address Line 2"
                                                   type="text"
                                                   required
                                            >
                                        </div>

                                        <div class="form-group mb-2">
                                            <label :for="compAddress3">
                                                <strong>
                                                    Address Line 3
                                                </strong>
                                            </label>
                                            <input class="form-control"
                                                   :id="compAddress3"
                                                   :name="compAddress3"
                                                   v-model="address3"
                                                   placeholder="Address Line 3 (optional)"
                                                   type="text"
                                            >
                                        </div>

                                        <div class="form-group mb-2">
                                            <label :for="compAddress4">
                                                <strong>
                                                    Address Line 4
                                                </strong>
                                            </label>
                                            <input class="form-control"
                                                   :id="compAddress4"
                                                   :name="compAddress4"
                                                   v-model="address4"
                                                   placeholder="Address Line 4 (optional)"
                                                   type="text"
                                            >
                                        </div>

                                        <div class="form-group">
                                            <label :for="compPostcode">
                                                <strong>
                                                    Postcode
                                                    <span class="text-danger">*</span>
                                                </strong>
                                            </label>
                                            <input class="form-control"
                                                   :id="compPostcode"
                                                   :name="compPostcode"
                                                   v-model="postcode"
                                                   placeholder="Postcode"
                                                   type="text"
                                                   required
                                            >
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>

                <div class="modal-footer">
                    <button type="button"
                            :id="compCloseButton"
                            class="btn btn-secondary"
                            data-bs-dismiss="modal">Close</button>

                    <button type="button" class="btn btn-primary" @click="createNewContactRequest" >Save</button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

    import axios from 'axios';
    import { successAlert, errorAlert } from '@/utils.js';
    import VSelect from 'vue-select';
    import CustomerSelect from "@/components/movements/components/CustomerSelect.vue";

    export default {

        components: {
            CustomerSelect,
            VSelect,
        },

        props: {
            selectedCustomer: {
                type: Object,
                default: null,
            },
            identifier: {
                type: String,
                default: '',
            },
            user: {
                type: Object,
                default: {},
            },
        },

        data() {
            return {
                internalUser: this.user,

                name: '',
                position: '',
                email: '',
                number: '',
                address1: '',
                address2: '',
                address3: '',
                address4: '',
                postcode: '',

                contacts: [],
            }
        },

        methods: {
            createNewContactRequest () {
                const data = {
                    customer_id: this.internalSelectedCustomer.id,
                    user_id: this.user.id,
                    contact_name: this.name,
                    contact_email: this.email,
                    position: this.position,
                    contact_number: this.number,
                    address1: this.address1,
                    address2: this.address2,
                    address3: this.address3,
                    address4: this.address4,
                    postcode: this.postcode
                };

                axios.post(route('api.movements.contacts.store'), data)
                .then(response => {
                    this.$emit('contact-created', response.data);
                    successAlert('Contact Created!', 'Success');
                    window.jQuery('.modal-header .btn-close').click();
                })
                .catch(errors => {
                    errorAlert(errors, 'Error Creating Contact');
                });
            },
        },

        computed: {
            internalSelectedCustomer() {
                return this.selectedCustomer ?? {};
            },
            compModal() {
                return this.identifier + '_contact_modal';
            },
            compCloseButton() {
                return this.identifier + '_close_button';
            },
            compName() {
                return this.identifier + '_name';
            },
            compPosition() {
                return this.identifier + '_position';
            },
            compEmail() {
                return this.identifier + '_email';
            },
            compNumber() {
                return this.identifier + '_number';
            },
            compAddress1() {
                return this.identifier + '_address1';
            },
            compAddress2() {
                return this.identifier + '_address2';
            },
            compAddress3() {
                return this.identifier + '_address3';
            },
            compAddress4() {
                return this.identifier + '_address4';
            },
            compPostcode() {
                return this.identifier + '_postcode'
            }
        },

    }

</script>
